import {
    Award, PackageCheck, Building2, Rocket, IndianRupee, FileText, ShieldCheck,
    Headset, SlidersHorizontal, MapPin,
} from "lucide-react";

const REASONS = [
    { icon: Award, title: "Certified Engineers", desc: "Cisco, Aruba, Fortinet certified specialists on staff." },
    { icon: PackageCheck, title: "Genuine Products", desc: "OEM-sourced hardware with full warranty coverage." },
    { icon: Building2, title: "Enterprise Solutions", desc: "Designs proven at campus and data center scale." },
    { icon: Rocket, title: "Fast Deployment", desc: "Structured rollouts with clear timelines and milestones." },
    { icon: IndianRupee, title: "Affordable Pricing", desc: "Transparent BOQs and best-in-class commercials." },
    { icon: FileText, title: "Professional Documentation", desc: "Complete network diagrams, SOPs and handover packs." },
    { icon: ShieldCheck, title: "Reliable AMC", desc: "SLA-backed maintenance contracts with rapid response." },
    { icon: Headset, title: "Dedicated Support", desc: "Named account engineers and 24×7 remote helpdesk." },
    { icon: SlidersHorizontal, title: "Customized Solutions", desc: "Every deployment tailored to your workflows." },
    { icon: MapPin, title: "Nationwide Service", desc: "On-site engineers dispatched across India." },
];

export default function WhyChoose() {
    return (
        <section id="why" className="py-20 lg:py-28 bg-slate-50" data-testid="why-choose-section">
            <div className="container-lg">
                <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-12">
                    <div>
                        <span className="text-xs font-bold tracking-[0.24em] uppercase text-brand">Why CoreCyrus</span>
                        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-navy">
                            Built for uptime. Trusted for the long run.
                        </h2>
                    </div>
                    <p className="max-w-md text-slate-600">
                        Ten reasons enterprises across sectors choose CoreCyrus for mission-critical
                        networking projects — and stay for the AMC.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3">
                    {REASONS.map((r) => (
                        <div
                            key={r.title}
                            data-testid={`reason-${r.title.toLowerCase().replace(/\s+/g, "-")}`}
                            className="rounded-2xl bg-white border border-slate-200 p-5 hover:border-brand/40 hover:shadow-[0_12px_28px_rgba(10,37,64,0.06)] transition-[box-shadow,border-color]"
                        >
                            <div className="w-10 h-10 rounded-lg bg-navy text-white flex items-center justify-center">
                                <r.icon className="w-5 h-5" />
                            </div>
                            <div className="mt-4 font-display text-base font-semibold text-navy">{r.title}</div>
                            <div className="mt-1.5 text-sm text-slate-600 leading-relaxed">{r.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
